const [siteUrl, setSiteUrl] = window.location.origin;
export const listMeida = [
    {
        id:"1",
        val:"5",
        label:"Photo Gloss",
        permalink: "photo-gloss",
        url:`${siteUrl}/product/photo-gloss/`,
        prodid: "218621"
    },
    {
        id:"2",
        val:"6",
        label:"Photo Satin",
        permalink: "photo-satin",
        url:`${siteUrl}/product/photo-satin/`,
        prodid: "161210"
    },
    {
        id:"3",
        val:"6",
        label:"Photo Matte",
        permalink: "photo-matte",
        url:`${siteUrl}/product/photo-matte/`,
        prodid: "161254"
    },
    {
        id:'4',
        val:"4",
        label:"Photo Economy",
        permalink: "photo-economy",
        url:`${siteUrl}/product/photo-economy/`,
        prodid: "161259"
    },
    {
        id:'5',
        val:"8",
        label:"Backlit Film",
        permalink: "backlit-film",
        url:`${siteUrl}/product/backlit-film/`,
        prodid: "161292"
    },
    {
        id:'6',
        val:"10",
        label:"Adhesive Backlit Film",
        permalink: "adhesive-backlit-film",
        url:`${siteUrl}/product/adhesive-backlit-film/`,
        prodid: "161307"
    },
    {
        id:'7',
        val:"10",
        label:"Clear Transparency Film",
        permalink: "clear-transparency-film",
        url:`${siteUrl}/product/clear-transparency-film/`,
        prodid: "161488"
    },
    {
        id:'8',
        val:"8",
        label:"Matte Canvas",
        permalink: "matte-canvas",
        url:`${siteUrl}/product/matte-canvas/`,
        prodid: "161479"
    },
    {
        id:'9',
        val:"8",
        label:"Satin Canvas",
        permalink: "satin-canvas",
        url:`${siteUrl}/product/satin-canvas/`,
        prodid: "161480"
    },
    {
        id:'10',
        val:"8",
        label:"Adhesive Vinyl",
        permalink: "adhesive-vinyl",
        url:`${siteUrl}/product/adhesive-vinyl/`,
        prodid: "161485"
    },
    {
        id:'11',
        val:"6",
        label:"Vinyl Banner",
        permalink: "vinyl-banner",
        url:`${siteUrl}/product/vinyl-banner/`,
        prodid: "161486"
    },
    {
        id:'12',
        val:"10",
        label:"View Thru Vinyl",
        permalink: "view-thru-vinyl",
        url:`${siteUrl}/product/view-thru-vinyl/`,
        prodid: "161481"
    },
    {
        id:'13',
        val:"10",
        label:"Window Cling - White",
        permalink: "window-cling-white",
        url:`${siteUrl}/product/window-cling-white/`,
        prodid: "161482"
    },
    {
        id:'14',
        val:"10",
        label:"Window Cling - Clear",
        permalink: "window-cling-clear",
        url:`${siteUrl}/product/window-cling-clear/`,
        prodid: "161483"
    },
    {
        id:'15',
        val:"10",
        label:"Wall Flair Removable Vinyl",
        permalink: "wall-flair-removable-vinyl",
        url:`${siteUrl}/product/wall-flair-removable-vinyl/`,
        prodid: "161487"
    }
];

export const portraitList = [
    {
        val:"1",
        label:'18" x 24"', 
        width: 18,
        height:24,
        prodid: 161448
    },
    {
        val:"2",
        label:'24" x 36"', 
        width: 24,
        height:36,
        prodid: 161385
    },
    {
        val:"3",
        label:'36" x 48"', 
        width: 36,
        height:48,
        prodid: 161351
    },
];

export const landscapeList = [
    {
        val:"4",
        label:'24" x 18"', 
        width: 24,
        height:18,
        prodid: 161464
    },
    {
        val:"5",
        label:'36" x 24"', 
        width: 36,
        height:24,
        prodid: 161368
    },
    {
        val:"6",
        label:'48" x 36"', 
        width: 48,
        height:36,
        prodid: 161327
    },
];

export const customeSize = {
    val:"7",
    label:'ENTER A CUSTOM SIZE', 
}

export const description = {
    orientation:"If you started your order by entering the wrong values for height and width (ie: uploaded a portrait image but enter landscape values), you can toggle the orientation of your poster to match the orientation of the image you uploaded.",
    aspect_ration:"Use this toggle to lock or unlock the blue image handles. When locked, your image will maintain aspect ratio and size up and down proportionally. When unlocked, you can use the handles to stretch your image to fit the page size, but this can result in distortion if you stretch very far.",
    size_to_fit_image:"Use this toggle to change the size of your requested print size to match the size of your uploaded image. This allows you to change your print size to match the aspect ratio of your image to avoid cropping or stretching of the source image. Take care to note the new size of the print you will receive.",
    image_scale_to:"By default your uploaded image has been placed to fill your requested print size. You can drag and move it around to adjust any cropping, or toggle between fit and fill modes to see how your image fits within your requested print size. If you see white space, that will be in your print. You can drag the blue circles in the corners to resize. Use the fit/fill toggle again to reset the image.",
    white_space:"If you see white space within the gray border around your uploaded image, it means your image does not fit proporEonally to the print size you requested. You can resize it to fill the white space by dragging the blue circles in the corners, or by using the Fit/Fill or Size to Fit toggles above.",
    viewer_lock: "Unlock the viewer if you need to move, size, or scale your image on your layout.",
    print_size: "Your image will be printed at the requested print size below: ",
    // help1: "We've loaded your file into the print layout window on the left.  The print size you are requesting does not match the aspect ratio of the file you uploaded.  Use the blue handles on the corners of the crop tool to size and crop the image to fit your requested print size.  You can move and resize the crop tool by clicking on it.  The blue dots in the corners allow you to resize.",
    // help2: "This is a preview of your uploaded image at your requested print size. You can change your file, download a proof, toggle between portrait and landscape orientation, or click 'Continue' to move to the next step.",
    help1: "We've placed your uploaded file onto the print layout window sized to fit your requested print size. You can click on it to drag, move, and crop your image to fit, and you can use the blue dots in the corners to resize.  Use the toggles to further adjust your image to fit or change your print size to match your image size.",
    help2: "We've placed your uploaded file onto the print layout window sized to fit your requested print size. You can click on it to drag, move, and crop your image to fit, and you can use the blue dots in the corners to resize.  Use the toggles to further adjust your image to fit or change your print size to match your image size.",
}

export const errorMessages = {
    invalidError: {
        headline: "Invalid File Type",
        body_text: "We’ve detected you’re uploading a file type that we don’t support. Please go back and select a:",
        bullet_text: ".jpg, .png, .pdf, .tif",
        warning_text: "If you believe your file is already one of these file types, it could be corrupt. Please try a different file to check, or try converting the file on your computer to one of these file types.",
        button_type: "goback"
    },
    proofError: {
        headline: "Cannot Generate Proof",
        body_text: "We’re having an issue generating a proof of this file. You can still continue and checkout and we will print from your original file.",
        bullet_text: "",
        warning_text: "Occasionally we cannot generate a proof from very large or complex file types for online viewing. As you continue, you’ll see a thumbnail that is an approximate representation of your print.",
        button_type: "continue"
    },
    processingError: {
        headline: "Error Processing File",
        body_text: "We’re having difficulty processing this file with our order wizard. Please try a different file, or use our Advanced Order method to use this file.",
        bullet_text: "",
        warning_text: "Our order wizard must render and process your file for online viewing. Some large or complex file types are difficult to process. You can still use the file to place an order with our Advanced Order, which skips the online processing and sends the file directly to us for printing.",
        button_type: "retryoradvanced"
    },
    uploadError: {
        headline: "Error Uploading File",
        body_text: "There was an error uploading this file. This could be a temporary glitch, please try one more time. If the problem persists, please try a different file, or use our Advanced Order method to use this file.",
        bullet_text: "",
        warning_text: "Our order wizard must render and process your file for online viewing. Some large or complex file types are difficult to process. You can still use the file to place an order with our Advanced Order, which skips the online processing and sends the file directly to us for printing.",
        button_type: "retryoradvanced"
    }
}